// extracted by mini-css-extract-plugin
module.exports = {"sections":"bFPY1anW","lowLinks":"YZkCxF_1","section":"E1vCwlHB","title":"_59V48MQ9","list":"pJ1oYaRx","listItem":"_6UcHnxdV"};